import { render, staticRenderFns } from "./ModalWorkingDays.vue?vue&type=template&id=3a60f8d9&scoped=true"
import script from "./ModalWorkingDays.vue?vue&type=script&lang=ts"
export * from "./ModalWorkingDays.vue?vue&type=script&lang=ts"
import style0 from "./ModalWorkingDays.vue?vue&type=style&index=0&id=3a60f8d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60f8d9",
  null
  
)

export default component.exports